// import React, { useContext } from "react";
// import { useLog } from "contexts/LogReservationContext";

// const LogReservation = ({reservationId}) => {
//   // const { logs } = useContext(LogReservationContext);
//   const { logs, filterOption } = useLog();
//   console.log("LogReservation", logs);
//   const logList = logs.data;
//   return (
//     <div className="card-body">
//       <table className="table">
//         <thead>
//           <tr>
//             <th>Date/Time</th>
//             <th>User</th>
//             <th>Description</th>
//           </tr>
//         </thead>
//         <tbody>
//           {logList.map((log) => (
//             <tr key={log.date}>
//               <td>{log.created_at}</td>
//               <td>{log.user.name}</td>
//               <td>{log.description}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default LogReservation;

import React, { useEffect, useState } from "react";
import { useLog } from "contexts/LogReservationContext";
import dayjs from "dayjs";
import { formatPrice } from "utils/utils";

const LogReservation = ({ booking }) => {
  const { logs, filterOptions } = useLog();
  const [openAccordion, setOpenAccordion] = useState(null);

  useEffect(() => {
    if (booking.id) {
      filterOptions.filters.subject.id = booking.id;
    }
  }, [booking.id]);

  if (!logs.data || logs.data.length === 0) {
    return <p>No logs available for this reservation.</p>;
  }

  // Helper to pretty print object diff, including labels and activities, with left (before) and right (after) columns
  const renderDiff = (before, after) => {
    if (!before && !after) return <em>No data</em>;
    const allKeys = Array.from(
      new Set([
        ...(before ? Object.keys(before) : []),
        ...(after ? Object.keys(after) : []),
      ])
    );
    // Exclude labels and activities from main table
    const mainKeys = allKeys.filter(
      (k) => k !== "labels" && k !== "activities"
    );

    return (
      <div className="row">
        {/* Before (kiri) */}
        <div className="col-md-6">
          <div className="mb-2">
            <strong>Before</strong>
          </div>
          <table className="table table-sm table-bordered mb-2">
            <tbody>
              {mainKeys.map((key) => (
                <tr
                  key={key}
                  style={
                    before?.[key] !== after?.[key]
                      ? { background: "#ffe5e5" }
                      : {}
                  }
                >
                  <td className="fw-bold">{key}</td>
                  <td>
                    {typeof before?.[key] === "object"
                      ? JSON.stringify(before[key])
                      : String(before?.[key] ?? "")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Labels before */}
          <div className="mb-2">
            <strong>Labels</strong>
          </div>
          <table className="table table-sm table-bordered mb-2">
            <tbody>
              {(before?.labels || []).map((label) => {
                // Highlight jika label di before tidak ada di after (removed) atau berubah
                const afterLabel = (after?.labels || []).find(l => l.id === label.id);
                const isChanged = afterLabel && JSON.stringify(label) !== JSON.stringify(afterLabel);
                const isRemoved = !afterLabel;
                return (
                  <tr key={label.id} style={isRemoved || isChanged ? { background: '#ffe5e5' } : {}}>
                    <td>{label.name}</td>
                    <td>
                      <span
                        style={{
                          background: label.color,
                          color: "#fff",
                          padding: "2px 8px",
                          borderRadius: 4,
                        }}
                      >
                        {label.color}
                      </span>
                    </td>
                  </tr>
                );
              })}
              {(!before?.labels || before.labels.length === 0) && (
                <tr>
                  <td colSpan={2}>
                    <em>No labels</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* Activities before */}
          <div className="mb-2">
            <strong>Activities</strong>
          </div>
          <table className="table table-sm table-bordered mb-2">
            <tbody>
              {(before?.activities || []).map((act) => {
                // Highlight jika activity di before tidak ada di after (removed) atau berubah
                const afterAct = (after?.activities || []).find(a => a.id === act.id);
                const isChanged = afterAct && JSON.stringify(act) !== JSON.stringify(afterAct);
                const isRemoved = !afterAct;
                return (
                  <tr key={act.id} style={isRemoved || isChanged ? { background: '#ffe5e5' } : {}}>
                    <td>{act.activity}</td>
                    <td>{act.qty}</td>
                    <td>{formatPrice(act.price)}</td>
                  </tr>
                );
              })}
              {(!before?.activities || before.activities.length === 0) && (
                <tr>
                  <td colSpan={3}>
                    <em>No activities</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* After (kanan) */}
        <div className="col-md-6">
          <div className="mb-2">
            <strong>After</strong>
          </div>
          <table className="table table-sm table-bordered mb-2">
            <tbody>
              {mainKeys.map((key) => (
                <tr
                  key={key}
                  style={
                    before?.[key] !== after?.[key]
                      ? { background: "#ffe5e5" }
                      : {}
                  }
                >
                  <td className="fw-bold">{key}</td>
                  <td>
                    {typeof after?.[key] === "object"
                      ? JSON.stringify(after[key])
                      : String(after?.[key] ?? "")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Labels after */}
          <div className="mb-2">
            <strong>Labels</strong>
          </div>
          <table className="table table-sm table-bordered mb-2">
            <tbody>
              {(after?.labels || []).map((label) => {
                // Highlight jika label di after tidak ada di before (added) atau berubah
                const beforeLabel = (before?.labels || []).find(l => l.id === label.id);
                const isChanged = beforeLabel && JSON.stringify(label) !== JSON.stringify(beforeLabel);
                const isAdded = !beforeLabel;
                return (
                  <tr key={label.id} style={isAdded || isChanged ? { background: '#ffe5e5' } : {}}>
                    <td>{label.name}</td>
                    <td>
                      <span
                        style={{
                          background: label.color,
                          color: "#fff",
                          padding: "2px 8px",
                          borderRadius: 4,
                        }}
                      >
                        {label.color}
                      </span>
                    </td>
                  </tr>
                );
              })}
              {(!after?.labels || after.labels.length === 0) && (
                <tr>
                  <td colSpan={2}>
                    <em>No labels</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* Activities after */}
          <div className="mb-2">
            <strong>Activities</strong>
          </div>
          <table className="table table-sm table-bordered mb-2">
            <tbody>
              {(after?.activities || []).map((act) => {
                // Highlight jika activity di after tidak ada di before (added) atau berubah
                const beforeAct = (before?.activities || []).find(a => a.id === act.id);
                const isChanged = beforeAct && JSON.stringify(act) !== JSON.stringify(beforeAct);
                const isAdded = !beforeAct;
                return (
                  <tr key={act.id} style={isAdded || isChanged ? { background: '#ffe5e5' } : {}}>
                    <td>{act.activity}</td>
                    <td>{act.qty}</td>
                    <td>{formatPrice(act.price)}</td>
                  </tr>
                );
              })}
              {(!after?.activities || after.activities.length === 0) && (
                <tr>
                  <td colSpan={3}>
                    <em>No activities</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body bg-light">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-primary">
            <tr>
              <th>Date/Time</th>
              <th>User</th>
              <th>Description</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {logs.data.map((log, idx) => (
              <React.Fragment key={log.id || log.created_at}>
                <tr>
                  <td>{dayjs(log.created_at).format("DD MMMM YYYY, HH:mm")}</td>
                  <td>{log.user?.name || "Unknown User"}</td>
                  <td>{log.description}</td>
                  <td>
                    <button
                      className={`btn btn-sm ${
                        openAccordion === idx
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      type="button"
                      onClick={() =>
                        setOpenAccordion(openAccordion === idx ? null : idx)
                      }
                    >
                      {openAccordion === idx ? "Hide" : "Show"}
                    </button>
                  </td>
                </tr>
                {openAccordion === idx && (
                  <tr>
                    <td colSpan={4} className="bg-white">
                      <div className="p-3 rounded border shadow-sm bg-body">
                        <strong>Before / After:</strong>
                        {log.properties ? (
                          renderDiff(
                            log.properties.before,
                            log.properties.after
                          )
                        ) : (
                          <em>No diff data</em>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4" className="bg-primary text-white">
                {logs.data.length} log(s) found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      {/* print json */}
      <div className="card-footer">
        <pre className="text-muted" style={{ fontSize: "12px" }}>
          {JSON.stringify(logs.data, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default LogReservation;
